<section class="flex flex-col justify-center items-center w-full min-h-screen px-4 py-8 overflow-y-auto bg-surface text-on-background relative">

  <div class="w-full max-w-md z-10 my-auto">
    <div class="w-full bg-surface-container-lowest border rounded-card-lg shadow-card p-8 md:p-10 flex flex-col items-center text-center transition-all duration-300">
      <div class="h-8 mb-8">
        <app-logo color="primary"></app-logo>
      </div>

      <div class="flex items-center justify-center w-16 h-16 mb-6 rounded-full text-primary">
        <ion-icon name="compass-outline" class="text-3xl"></ion-icon>
      </div>

      <p class="text-4xl font-extrabold text-primary leading-none">404</p>

      <h1 class="mt-4 text-lg font-bold text-on-background">
        {{ 'shared.errors.pageNotFound' | translate }}
      </h1>

      <app-filled-button expand="full" class="w-full mt-8" (click)="goHome()">
        {{ 'shared.errors.backToHome' | translate }}
      </app-filled-button>
    </div>
  </div>
</section>
